
import { Component, Mixins, Prop } from 'vue-property-decorator';
import UserRightsMixin from '~/mixins/UserRightsMixin';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component
export default class RemoteFeatureReleaseButtons extends Mixins(DarkThemeInfoMixin, UserRightsMixin) {
    @Prop() flagProgression!: number | null;

    release() {
        if (this.flagProgression === 100) return;
        this.$emit('openRolloutModal');
    }

    revert() {
        if (
            this.flagProgression !== null &&
            this.flagProgression > 0 &&
            !this.isDisabled &&
            confirm('Are you sure you want to revert this feature flag?'))
        {
            this.$emit('revertFlag');
        }
    }

    getReleaseLabel() {
        const flagProgression = this.flagProgression;

        if (flagProgression === null) return 'Start rollout';
        if (flagProgression === 100) return 'Released';

        return 'Update rollout';
    }

    getBtnBackground() {
        if(this.flagProgression !== 100) return 'grey lighten-3';
        return 'success';
    }

    get isDisabled() {
        return !this.isAllowed('RemoteFeatureFlagsNetatmo', 'release');
    }
}
